import { render, staticRenderFns } from "./combo-setting.vue?vue&type=template&id=666223cc&scoped=true"
import script from "./combo-setting.vue?vue&type=script&lang=js"
export * from "./combo-setting.vue?vue&type=script&lang=js"
import style0 from "./combo-setting.vue?vue&type=style&index=0&id=666223cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666223cc",
  null
  
)

export default component.exports